import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from "src/environments/environment";
import { IDataTerritories } from '../Models/IDataTerritories';
import { TerritoriesListItem, TerritoryVirtualLocationsDTO } from '../Models/TerritoriesListItem';
import { TerritoriesService } from './TerritoriesService.service';
import { TerritoriesLayerControlService } from './TerritoriesLayerControl.service';
import { TerritoryRouteTypeEnum } from '../utilities/enums/TerritoriesEnum';
import { LocationDTO } from '../../locations-section/models/LocationDTO';
import { FeatureCollection } from '@turf/helpers';
import { PolygonDrawToolService } from 'src/services/maps/features/PolygonDrawTool.service';
@Injectable({
  providedIn: 'root'
})
export class PanelEditTerritoriesService {
  

  private territoryItemList : TerritoriesListItem[] = [];
  
  isVisibleDetails$: Subject<boolean> = new Subject<boolean>();
  
  private isLoading$: Subject<boolean> = new Subject();

  constructor(private territoriesService: TerritoriesService, private territoriesLayerService: TerritoriesLayerControlService, private polygonDrawService: PolygonDrawToolService) {
    
  }
  setLoading(resp) {
    this.isLoading$.next(resp);
  }

  getLoading() {
    return this.isLoading$.asObservable();
  }

  setData(territoryItemList: TerritoriesListItem[]) {
    this.territoryItemList = territoryItemList;
  }

  getData(): {territoryItemList: TerritoriesListItem[]} {
    return {territoryItemList: this.territoryItemList};
  }

  setSelectedLocations(territoryLocations: { [key: string]: TerritoryVirtualLocationsDTO[] }) {
    this.territoriesLayerService.setSelectedLocations(territoryLocations);
  }

  getSelectedLocations(){
    return this.territoriesLayerService.getSelectedLocations();
  }

  // initializeLayers(){
  //   this.territoriesLayerService.initializeDetailTerritoryLayers();
  // }

  activatePolygonDrawMode(){
    this.polygonDrawService.addTerritoryLocationPolygonDrawControl();
  }

  deactivatePolygonDrawMode(){
    this.polygonDrawService.removeTerritoryLocationPolygonDrawControl();
  }

  addLocationsToSelected(territoryLocations: { [key: string]: TerritoryVirtualLocationsDTO[] }) {
    this.territoriesLayerService.addLocationsToSelected(territoryLocations);
  }

  createReorderedGeoJson(territoryLocations: { [key: string]: TerritoryVirtualLocationsDTO[] }): FeatureCollection {
    const reorderedGeoJson = this.territoriesLayerService.createReorderedGeoJson(territoryLocations);
    return reorderedGeoJson;
  }

  clearLocationsState(locationIdentifier: string = null){
    this.territoriesLayerService.clearLocationsState('all', locationIdentifier);
  }

  openDetailsPopup(identifier: any, parentCoordX: string, parentCoordY: string){
    this.territoriesLayerService.openLocationPopup(identifier, parentCoordX, parentCoordY, 'detail');
  }

  addActiveTerritoryPolygonFilter(territoryId: string) {
    this.territoriesLayerService.addActiveTerritoryPolygonFilter(territoryId);
  }

  removeActiveTerritoryPolygonFilter(territoryId: string) {
    this.territoriesLayerService.removeActiveTerritoryPolygonFilter(territoryId);
  }

  addActiveTerritoryLocationFilter(territoryIdentifier: string) {
    this.territoriesLayerService.addActiveTerritoryLocationFilter(territoryIdentifier);
  }

  removeActiveTerritoryLocationFilter(territoryIdentifier: string) {
    this.territoriesLayerService.removeActiveTerritoryLocationFilter(territoryIdentifier);
  }

  removeFilters(){
    this.territoriesLayerService.removeFilters();
  }

  loadMorePolygonGeoJson(geoJson: any){
    this.territoriesLayerService.loadMorePolygonGeoJson('all', geoJson);
  }

  loadPolygonGeoJson(geoJson: any){
    this.territoriesLayerService.loadPolygonGeoJson('all', geoJson);
  }

  resetPolygonGeoJson(){
    this.territoriesLayerService.resetPolygonGeoJson('all');
  }

  loadMoreLocationGeoJson(geoJson: any){
    this.territoriesLayerService.loadMoreLocationGeoJson('all', geoJson);
  }

  updateLocationGeoJsonPreservingStates(geoJson: any){
    this.territoriesLayerService.updateLocationGeoJsonPreservingStates('all', geoJson);
  }

  resetLocationGeoJson(){
    this.territoriesLayerService.resetLocationGeoJson('all');
  }

  assignColor(identifier: string){
    return this.territoriesLayerService.assignColor(identifier);
  }

  destroyLayers(){
    this.territoriesLayerService.destroySourceAndLayers();
    this.polygonDrawService.removeTerritoryLocationPolygonDrawControl();
  }

}
